'use strict';

define('scrollTo',['jquery', 'jquery.easing'], function ($) {

  var
    $content          = $('.content'),
    $scrollButtonTop  = $('#js-button-scroll-top'),
    $scrollButton     = $('#js-button-scroll-content'),
    $scrollButtonHero = $('#js-button-scroll-content-hero'),

    opts = {
      header_height: 60,
      subNav_height: $('.subnavigation-container').outerHeight(),
      animation_speed: 300,
      animation_easing: 'easeInCirc'
    };

  
  /*
  * scrollTo function
  * Position to scroll passed in e.data.pos_to_scroll
  */
  var scrollTo = function(e) {
    var pos_to_scroll = e.data.pos_to_scroll;

    $('html, body').animate({
      scrollTop: pos_to_scroll
    }, opts.animation_speed, opts.animation_easing);
  };

  var initialize = function() {
    attachEvents();
  };

  var attachEvents = function() {
    $scrollButton.on('click', {
      pos_to_scroll: $content.length && $content.offset().top - opts.header_height
    }, scrollTo);

    $scrollButtonTop.on('click', {
      pos_to_scroll: 0
    }, scrollTo);

    $scrollButtonHero.on('click', {
      pos_to_scroll: $content.length && $content.offset().top - opts.header_height - opts.subNav_height
    }, scrollTo);
  };

  return {
    init: initialize
  };

});
